import * as React from 'react';
export var QuestionnaireListContext = React.createContext([]);
export var QuestionnaireListProvider = function (_a) {
    var children = _a.children;
    var _b = React.useState(), questionnaireList = _b[0], setQuestionnaireList = _b[1];
    var value = [questionnaireList, setQuestionnaireList];
    return React.createElement(QuestionnaireListContext.Provider, { value: value }, children);
};
